import React, { Component } from 'react';
import { get } from 'lodash';
import glamorous from 'glamorous';
import { Text, Icon, blue600 } from 'pp-react';

import DonationBox from './donation-box';
import DonationTerms from './donation-terms';
import { Delay } from './redux/components/styles/animation';

import styles from './charity.less';

import { getType } from '../lib/charity';
import Icons from './icons';

import content from '../lib/i18n';
const i18n = content('app/components/charity');

const DelayedDiv = glamorous.div(
  Object.assign({}, Delay, {
    paddingLeft: '50px',

    '@media(min-width: 768px)': {
      borderLeft: '1px solid #DBDBDB',
    },
  })
);

const CharityPanel = glamorous.div({
  height: 'auto',
  width: '85%',
  maxWidth: '1300px',
  textAlign: 'center',
  margin: '0 auto',
  position: 'relative',

  '@media(max-width: 480px)': {
    width: '100%',
  },
});

const NPOAvatarContainer = glamorous.div({
  textAlign: 'center',
  overflow: 'hidden',
  width: '105px',
  cursor: 'pointer',
  height: '105px',
  borderRadius: '68px',
  backgroundColor: 'white',
  boxShadow:
    '0 8px 11px 0 rgba(0, 0, 0, 0.08), 0 2px 5px 0 rgba(0, 0, 0, 0.08)',
  margin: 'auto',
});

const FeaturedCharitySectionHeader = glamorous(Text)(
  {
    margin: '20px 0',
  },
  ({ hide }) => (hide ? { display: 'none' } : '')
);

const FeaturedCharitySectionSubHeader = glamorous(Text)(
  {
    textAlign: 'center',
    margin: '0 auto',
  },
  ({ hide }) => (hide ? { display: 'none' } : '')
);

const FeaturedCharitySelectedCharityHeader = glamorous(Text)(
  {
    width: '68%',
    margin: '20px auto',
  },
  ({ hide }) => (hide ? { display: 'none' } : '')
);

const FeaturedCharitySeeMore = glamorous(Text)(
  {
    display: 'inline',
    cursor: 'pointer',
    color: blue600,
    marginTop: '30px',
  },
  ({ hide }) => (hide ? { display: 'none' } : '')
);

const FeaturedCharityBack = glamorous(Icon)(
  {
    float: 'left',
    marginTop: '16px',
    color: blue600,
  },
  ({ hide }) => (hide ? { display: 'none' } : '')
);

export class charity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      charities: (props.charities || []).filter(c => {
        return !!c;
      }),
    };

    this.handleHover = this.handleHover.bind(this);
    this.handleClickSeeMore = this.handleClickSeeMore.bind(this);
  }

  handleHover() {
    this.setState({
      hover: true,
    });
  }

  handleClickSeeMore() {
    this.props.handleSeeMore(this.props.source);
  }

  renderDonationError() {
    if (
      !this.props.selectedCharity &&
      get(this.props, 'donationInfo.donated') === 2 &&
      get(this.props, 'donationInfo.source') === this.props.source
    ) {
      return (
        <div>
          <div className={'landing-chkout-error-msg'}>
            {Icons.error}
            <Text as='p' size='md' className={'errStyling'}>
              {this.props.checkoutErrorMsg}
            </Text>
          </div>
        </div>
      );
    }
  }

  charityLogo(charity, index) {
    return (
      <div className={'logoCharity'} onMouseOver={this.handleHover}>
        <div style={{ margin: 'auto', position: 'relative' }}>
          <NPOAvatarContainer>
            <div
              className={'npo-avatar'}
              id={`charity-avatar-${index}`}
              onClick={this.props.onHandleClick.bind(
                null,
                index,
                this.props.source,
                charity.nonprofit_id
              )}
              style={{
                background: `url(${charity.logo_url}) no-repeat center, center`,
                backgroundSize: 'contain',
                width: '75px',
                height: '75px',
                margin: '15px',
              }}
              data-nemo='npo-avatar'
            />
          </NPOAvatarContainer>
        </div>
      </div>
    );
  }

  charityName(charity, index) {
    let charityNameStripped = charity.name || '';
    let charityNameLength = charityNameStripped.length;
    const npoUrl = `${this.props.npoBaseUrl}${charity.nonprofit_id}`;

    if (charityNameLength > 40) {
      charityNameStripped = charityNameStripped.substr(0, 40).concat('...');
    }

    return (
      <div className={'charityName'}>
        <Text as='p' size='md' regular className={'charitytext'}>
          {charityNameStripped}{' '}
          <a
            className={'infoIcon'}
            target={'_blank'}
            href={npoUrl}
            onClick={this.props.onInfoClick.bind(
              null,
              index,
              this.props.source,
              charity.nonprofit_id
            )}
          >
            <Icon name='info' size='xs' />
          </a>
        </Text>
      </div>
    );
  }

  charityPopover(charity, className) {
    const npoUrl = `${this.props.npoBaseUrl}${charity.nonprofit_id}`;
    return (
      <div className={className}>
        <span
          onClick={this.props.onPopoverClose.bind(null, this.props.source)}
          style={{
            right: '10px',
            top: '4px',
            position: 'absolute',
            zIndex: '100',
            cursor: 'pointer',
          }}
        >
          {Icons.close}
        </span>
        <p className={'charityNamePop'}>{charity.name}</p>
        <p className={'charityMission'}>{charity.slogan}</p>
        <div className={'npoLinkContainer'}>
          <a className={'visitNpoLink'} target={'_blank'} href={npoUrl}>
            {i18n('label.visit-page')}
          </a>
        </div>
      </div>
    );
  }

  renderSelectedCharity(charity) {
    const charityDiv = (
      <div className={'logo-container'}>
        {this.charityLogo(charity, this.props.selectedIndex)}
        {this.charityName(charity, this.props.selectedIndex)}
      </div>
    );

    return (
      <div className={'row'} style={{ marginTop: '40px' }}>
        <div className={'col-xs col-sm col-md col-lg-3'}>{charityDiv}</div>
        <div
          className={`col-xs col-sm col-md col-lg-5 ${
            styles['donation-form-container']
          }`}
        >
          {this.renderDonationBox()}
        </div>
        <div
          className={`col-xs col-sm col-md col-lg-4 ${
            styles['donation-terms-container']
          }`}
        >
          {this.renderDonationTerms(charity)}
        </div>
      </div>
    );
  }

  renderCharities(charities) {
    const charityList = charities.map((charity, index) => {
      return (
        <div key={index} className={'logo-container'}>
          {this.charityLogo(charity, index)}
          {this.charityName(charity, index)}
        </div>
      );
    });

    return (
      <div>
        <div
          className={'row col-xs-12 col-sm-6 col-md-4 col-lg-4'}
          style={{
            width: '100%',
            float: 'none',
            textAlign: 'center',
            margin: '0 auto',
            marginTop: '30px',
          }}
        >
          {charityList}
        </div>
      </div>
    );
  }

  renderLogoCharities() {
    const charitiesShown = this.state.charities.slice(
      0,
      this.props.seeMoreClicked * 6 + 6
    );

    if (this.props.selectedCharity) {
      const charity = charitiesShown[this.props.selectedIndex];
      return this.renderSelectedCharity(charity);
    } else {
      return this.renderCharities(charitiesShown);
    }
  }

  renderDonationBox() {
    const selectedCharityDetails =
      this.state.charities[this.props.selectedIndex] || {};
    return (
      <DonationBox
        charityDetails={selectedCharityDetails}
        amounts={this.props.amounts}
        csrf={this.props.csrf}
        source={this.props.source}
        {...this.props}
      />
    );
  }

  renderDonationTerms(charity) {
    if (charity) {
      const type = getType(charity);
      const charityContent = charity.charityContent;
      return (
        <DelayedDiv>
          <DonationTerms type={type} charityContent={charityContent} />
        </DelayedDiv>
      );
    }
  }

  renderBackLink() {
    const isCharitySelected = this.props.selectedCharity;

    return (
      <div className={'backDivStyling'}>
        <FeaturedCharityBack
          name='chevron-left'
          size='sm'
          hide={!isCharitySelected}
        />
        <Text
          as='p'
          regular
          size='md'
          className={`back ${isCharitySelected ? null : styles.hide}`}
          onClick={this.props.onHandleDefaultCharityState.bind(
            null,
            this.props.source
          )}
        >
          {i18n('label.back-link')}
        </Text>
      </div>
    );
  }

  renderShowMoreLink() {
    return (
      <FeaturedCharitySeeMore
        as='p'
        size='md'
        regular
        onClick={this.handleClickSeeMore}
        hide={
          this.props.selectedCharity ||
          this.props.seeMoreClicked * 6 + 6 >= this.state.charities.length
        }
      >
        {' '}
        {i18n('label.see-more')}{' '}
      </FeaturedCharitySeeMore>
    );
  }

  render() {
    return (
      <div id='chooseCharities'>
        <CharityPanel className={'panel'}>
          {this.renderBackLink()}
          <FeaturedCharitySectionHeader
            as='h3'
            size='xl3'
            hide={this.props.selectedCharity}
          >
            {this.props.charityModuleTitle
              ? this.props.charityModuleTitle
              : this.props.charityModuleTitleDefault}
          </FeaturedCharitySectionHeader>
          {this.renderDonationError()}
          <FeaturedCharitySectionSubHeader
            as='h3'
            size='lg'
            hide={
              this.props.selectedCharity ||
              (this.props.donationInfo && this.props.donationInfo.donated === 2)
            }
          >
            {this.props.charityModuleSubHeader || ''}
          </FeaturedCharitySectionSubHeader>
          <FeaturedCharitySelectedCharityHeader
            as='h3'
            size='xl3'
            hide={!this.props.selectedCharity}
          >
            {this.props.charityModuleChooseAmountText
              ? this.props.charityModuleChooseAmountText
              : this.props.charityModuleChooseAmountTextDefault}
          </FeaturedCharitySelectedCharityHeader>
          {this.renderLogoCharities()}
          {this.renderShowMoreLink()}
        </CharityPanel>
      </div>
    );
  }
}

export default charity;
